import { render, staticRenderFns } from "./charityReports.vue?vue&type=template&id=665a9b88&"
import script from "./charityReports.vue?vue&type=script&lang=js&"
export * from "./charityReports.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports